import request from '@/utils/request'

// 发送邮箱修改验证码
export function sendEmailChangeCode(newEmail) {
  return request({
    url: '/email/send-change-code',
    method: 'post',
    data: {
      new_email: newEmail
    }
  })
}

// 验证邮箱修改验证码
export function verifyEmailChangeCode(newEmail, code) {
  return request({
    url: '/email/verify-change-code',
    method: 'post',
    data: {
      new_email: newEmail,
      code: code
    }
  })
}

// 修改邮箱
export function changeEmail(newEmail, code) {
  return request({
    url: '/email/change',
    method: 'post',
    data: {
      new_email: newEmail,
      code: code
    }
  })
}
